import { BrowserRouter } from "react-router-dom";
import { Login } from "@pages/Login";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <Login />
    </BrowserRouter>
  );
}

export default App;
